import { useI18n as useVueI18n } from "vue-i18n";
import type { MessageSchema } from "@/engine/lang";

export default function useI18n() {
  return useVueI18n<{ message: MessageSchema }>({
    useScope: "global",
  });
}
